import { render, staticRenderFns } from "./StylingBox.vue?vue&type=template&id=0b427cd9&scoped=true"
import script from "./StylingBox.vue?vue&type=script&lang=js"
export * from "./StylingBox.vue?vue&type=script&lang=js"
import style0 from "./StylingBox.vue?vue&type=style&index=0&id=0b427cd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b427cd9",
  null
  
)

export default component.exports